export default "__VITE_ASSET__7c38da8c__"